import React from 'react';
import AddIcon from '@material-ui/icons/Add';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Fab from '@material-ui/core/Fab';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import UserLayout from './UserLayout'
import CitySelector from './CitySelector'
import { LinearProgress, Link, Typography } from '@material-ui/core';
const fabStyle = {
    margin: 0,
    top: 'auto',
    right: 20,
    bottom: 20,
    left: 'auto',
    position: 'fixed',
};

const formControl= {
    minWidth: 120,
    paddingTop:"10px"
};

const selectClass= {
    minWidth: 120,
};


class UserDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            authHandler: props.authHandler,
            revokeHandler: props.revokeHandler,
            open: false,
            address: null,
            loading: false,
            month: "",
            day: ""
        };
        this.handleClose = this.handleClose.bind(this);
    }

    addressUpdatedHandler = (address) => {
        this.setState({address: address});
    }

    handleClickOpen = () => {
        this.setState({open: true});
    };

    handleClose() {
        this.setState({open: false});
    };

    handleRemove = () => {
        var object = {
            tokens: this.props.user.tokens,
        };
        var ctx = this;
        ctx.setState({ loading: true });
        window.jQuery.ajax({
            url: 'https://uc4pf5uyvffabpzg4zpephfet40ocvsi.lambda-url.us-east-1.on.aws/',
            type: 'DELETE',
            data: JSON.stringify(object),
            success: function(data) {
                ctx.state.revokeHandler();
                ctx.setState({
                  open:false,
                  loading: false
              });
              alert("Your data has been deleted and all granted permissions have been revoked.");
            },
            error: function(a, b, error) {
                alert("Please tell mouser58907 you got the following error: " + JSON.stringify(error));
                ctx.setState({
                    open:true,
                    loading: false
                });
            }
          });
    };

    handleMonthChange = (event) => {
        this.setState({month: event.target.value});
    };

    handleDayChange = (event) => {
        this.setState({day: event.target.value});
    };

    submit = () => {
        var object = {
            tokens: this.props.user.tokens,
            location: this.state.address.location,
            city: this.state.address.city,
            region: this.state.address.region,
            country: this.state.address.country,
            lat: this.state.address.lat,
            long: this.state.address.lon,
            birthdate: this.state.month + "-" + this.state.day
        };
        var ctx = this;
        ctx.setState({ loading: true });
        window.jQuery.ajax({
            url: 'https://uc4pf5uyvffabpzg4zpephfet40ocvsi.lambda-url.us-east-1.on.aws/',
            type: 'POST',
            data: JSON.stringify(object),
            success: function(data) {
                ctx.setState({
                  open:false,
                  loading: false
              });
            },
            error: function(jqXHR, textStatus, error) {
                alert("Please tell mouser58907 you got the following error: " + error);
                console.log(jqXHR);
                console.log(textStatus);
                ctx.setState({
                    open:true,
                    loading: false
                });
            }
          });
    }

    render() {
        var disableButton = (this.state.address != null && this.props.user != null) ? false : true;
        return (
            <span>
                <Fab id="add_user" onClick={this.handleClickOpen} color="primary" aria-label="add" style={fabStyle}>
                    <AddIcon />
                </Fab>
                <Dialog open={this.state.open} onClose={this.handleClose} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">Join the Nerdle</DialogTitle>
                    <DialogContent>
                        <UserLayout user={this.props.user} authHandler={this.state.authHandler}/>
                        <CitySelector onSelect={this.addressUpdatedHandler}></CitySelector>
                        <FormControl style={formControl}>
                            <InputLabel htmlFor="select-month">Birthday</InputLabel>
                            <Select
                                labelId="month"
                                id="select-month"
                                style={selectClass}
                                value={this.state.month}
                                onChange={this.handleMonthChange}
                                >
                                <MenuItem value={""}>&nbsp;</MenuItem>
                                <MenuItem value={"1"}>January</MenuItem>
                                <MenuItem value={"2"}>February</MenuItem>
                                <MenuItem value={"3"}>March</MenuItem>
                                <MenuItem value={"4"}>April</MenuItem>
                                <MenuItem value={"5"}>May</MenuItem>
                                <MenuItem value={"6"}>June</MenuItem>
                                <MenuItem value={"7"}>July</MenuItem>
                                <MenuItem value={"8"}>August</MenuItem>
                                <MenuItem value={"9"}>September</MenuItem>
                                <MenuItem value={"10"}>October</MenuItem>
                                <MenuItem value={"11"}>November</MenuItem>
                                <MenuItem value={"12"}>December</MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl style={formControl}>
                            <InputLabel htmlFor="select-day">Day</InputLabel>
                            <Select
                                labelId="day"
                                id="select-day"
                                style={selectClass}
                                value={this.state.day}
                                onChange={this.handleDayChange}
                                >
                                <MenuItem value={""}>&nbsp;</MenuItem>
                                <MenuItem value={"1"}>01</MenuItem>
                                <MenuItem value={"2"}>02</MenuItem>
                                <MenuItem value={"3"}>03</MenuItem>
                                <MenuItem value={"4"}>04</MenuItem>
                                <MenuItem value={"5"}>05</MenuItem>
                                <MenuItem value={"6"}>06</MenuItem>
                                <MenuItem value={"7"}>07</MenuItem>
                                <MenuItem value={"8"}>08</MenuItem>
                                <MenuItem value={"9"}>09</MenuItem>
                                <MenuItem value={"10"}>10</MenuItem>
                                <MenuItem value={"11"}>11</MenuItem>
                                <MenuItem value={"12"}>12</MenuItem>
                                <MenuItem value={"13"}>13</MenuItem>
                                <MenuItem value={"14"}>14</MenuItem>
                                <MenuItem value={"15"}>15</MenuItem>
                                <MenuItem value={"16"}>16</MenuItem>
                                <MenuItem value={"17"}>17</MenuItem>
                                <MenuItem value={"18"}>18</MenuItem>
                                <MenuItem value={"19"}>19</MenuItem>
                                <MenuItem value={"20"}>20</MenuItem>
                                <MenuItem value={"21"}>21</MenuItem>
                                <MenuItem value={"22"}>22</MenuItem>
                                <MenuItem value={"23"}>23</MenuItem>
                                <MenuItem value={"24"}>24</MenuItem>
                                <MenuItem value={"25"}>25</MenuItem>
                                <MenuItem value={"26"}>26</MenuItem>
                                <MenuItem value={"27"}>27</MenuItem>
                                <MenuItem value={"28"}>28</MenuItem>
                                <MenuItem value={"29"}>29</MenuItem>
                                <MenuItem value={"30"}>30</MenuItem>
                                <MenuItem value={"31"}>31</MenuItem>
                            </Select>
                            <Typography>Birthdate is optional</Typography>
                        </FormControl>
                        {this.state.loading &&
                            <LinearProgress />
                        }
                    <p><a href="/homepage.html" target="_blank">More Info</a></p>
                    </DialogContent>
                    <DialogActions>
                        <Button disabled={!this.props.isAuthorized} onClick={this.handleRemove} color="secondary">
                            Remove Me
                        </Button>
                        <Button onClick={this.handleClose} color="secondary" variant="contained">
                            Cancel
                        </Button>
                        <Button onClick={this.submit} color="primary" disabled={disableButton} variant="contained">
                            Add to Map
                        </Button>
                    </DialogActions>
                </Dialog>
            </span>
        );

    }
}
export default UserDialog;


